import EditTheUser from "../../components/EditTheUser/EditTheUser";

const EditUser = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="home-container">
      <div className="bg-light-pink h-89">
        <div className="container flex items-center">
          <div className="flex items-center" onClick={handleGoBack}>
            <img
              src="/images/goback-icon.svg"
              alt="Go back"
              className="mr-2.5 w-7 h-7 cursor-pointer"
            />
            <p className="text-xl font-normal cursor-pointer">Go back</p>
          </div>
        </div>
      </div>
      <EditTheUser />
    </div>
  );
};

export default EditUser;
